import { ExposuresView } from '@/views/Dashboard/ExposuresView';

export function ExposuresPage() {
  return <ExposuresView />;
}
